import React, { useState } from 'react';
import { DataTable } from '../components/DataTable';
import { WizardForm } from '../components/WizardForm';
import { StatusBadge } from '../components/StatusBadge';
export function OrganizationManagement() {
  const [activeTab, setActiveTab] = useState<'list' | 'add'>('list');
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    orgName: '',
    businessType: '',
    country: '',
    website: '',
    address: '',
    contactName: '',
    phone: '',
    mobile: '',
    email: '',
    authName: '',
    authDesignation: '',
    authEmail: '',
    authPhone: '',
    bankName: '',
    branchName: '',
    accountName: '',
    accountNumber: '',
    routingNumber: '',
    legalDocs: ''
  });
  const [organizations, setOrganizations] = useState([{
    orgName: 'Sundarban Fisheries Ltd',
    email: 'info@sundarbanfish.com',
    idNumber: 'ORG-001',
    phone: '01711001122',
    businessType: 'Fisheries',
    status: 'approved' as const
  }, {
    orgName: 'Bay of Bengal Trading Co.',
    email: 'contact@bobtrade.com',
    idNumber: 'ORG-002',
    phone: '01811223344',
    businessType: 'Trading',
    status: 'approved' as const
  }, {
    orgName: 'Khulna Honey Producers',
    email: 'khp@gmail.com',
    idNumber: 'ORG-003',
    phone: '01911334455',
    businessType: 'Honey Production',
    status: 'approved' as const
  }, {
    orgName: 'Mongla Port Services',
    email: 'mps@mongla.com',
    idNumber: 'ORG-004',
    phone: '01611445566',
    businessType: 'Port Services',
    status: 'pending' as const
  }, {
    orgName: 'Satkhira Wood Industries',
    email: 'swi@satkhira.com',
    idNumber: 'ORG-005',
    phone: '01511556677',
    businessType: 'Wood Processing',
    status: 'approved' as const
  }]);
  const columns = [{
    key: 'orgName',
    label: 'Organization Name'
  }, {
    key: 'email',
    label: 'Email ID'
  }, {
    key: 'idNumber',
    label: 'ID Number'
  }, {
    key: 'phone',
    label: 'Phone Number'
  }, {
    key: 'businessType',
    label: 'Business Type'
  }, {
    key: 'status',
    label: 'Status',
    render: (value: string) => <StatusBadge status={value as any} data-id="element-1611" />
  }];
  const filters = [{
    key: 'businessType',
    label: 'Business Type',
    options: ['Fisheries', 'Trading', 'Honey Production', 'Port Services', 'Wood Processing']
  }, {
    key: 'status',
    label: 'Status',
    options: ['Approved', 'Pending', 'Rejected']
  }];
  const wizardSteps = [{
    title: 'Organization Info',
    description: 'Enter basic organization details'
  }, {
    title: 'Contact Info',
    description: 'Enter contact and authorized person details'
  }, {
    title: 'Bank Details',
    description: 'Enter banking information'
  }, {
    title: 'Documents',
    description: 'Upload legal documents'
  }, {
    title: 'Review & Submit',
    description: 'Review all information before submitting'
  }];
  return <div className="space-y-6" data-id="element-1612">
      <div data-id="element-1613">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1614">
          Organization Management
        </h1>
        <p className="text-sm text-gray-600 mt-1" data-id="element-1615">
          Manage registered organizations and companies
        </p>
      </div>

      <div className="border-b border-gray-200" data-id="element-1616">
        <div className="flex gap-4" data-id="element-1617">
          <button onClick={() => setActiveTab('list')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'list' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-1618">
            Organization List
          </button>
          <button onClick={() => setActiveTab('add')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'add' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-1619">
            Add Organization
          </button>
        </div>
      </div>

      {activeTab === 'list' && <DataTable columns={columns} data={organizations} filters={filters} onDataChange={setOrganizations} searchPlaceholder="Search organizations..." data-id="element-1620" />}

      {activeTab === 'add' && <WizardForm steps={wizardSteps} currentStep={currentStep} onStepChange={setCurrentStep} onSubmit={() => {
      if (!formData.orgName || !formData.businessType) {
        alert('Please fill in all required fields.');
        return;
      }
      alert(`Organization ${formData.orgName} registered successfully!`);
      setCurrentStep(0);
      setActiveTab('list');
      setFormData({
        orgName: '',
        businessType: '',
        country: '',
        website: '',
        address: '',
        contactName: '',
        phone: '',
        mobile: '',
        email: '',
        authName: '',
        authDesignation: '',
        authEmail: '',
        authPhone: '',
        bankName: '',
        branchName: '',
        accountName: '',
        accountNumber: '',
        routingNumber: '',
        legalDocs: ''
      });
    }} data-id="element-1621">
          {currentStep === 0 && <div className="space-y-4" data-id="element-1622">
              <div className="grid grid-cols-2 gap-4" data-id="element-1623">
                <div data-id="element-1624">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1625">
                    Organization Name *
                  </label>
                  <input type="text" required value={formData.orgName} onChange={e => setFormData({
              ...formData,
              orgName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1626" />
                </div>
                <div data-id="element-1627">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1628">
                    Business Type *
                  </label>
                  <select required value={formData.businessType} onChange={e => setFormData({
              ...formData,
              businessType: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1629">
                    <option value="" data-id="element-1630">Select Type</option>
                    <option value="Fisheries" data-id="element-1631">Fisheries</option>
                    <option value="Trading" data-id="element-1632">Trading</option>
                    <option value="Honey Production" data-id="element-1633">Honey Production</option>
                    <option value="Port Services" data-id="element-1634">Port Services</option>
                    <option value="Wood Processing" data-id="element-1635">Wood Processing</option>
                    <option value="Other" data-id="element-1636">Other</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1637">
                <div data-id="element-1638">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1639">
                    Business Operation Country
                  </label>
                  <input type="text" value={formData.country} onChange={e => setFormData({
              ...formData,
              country: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1640" />
                </div>
                <div data-id="element-1641">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1642">
                    Website
                  </label>
                  <input type="url" value={formData.website} onChange={e => setFormData({
              ...formData,
              website: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1643" />
                </div>
              </div>
              <div data-id="element-1644">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1645">
                  Communication Address
                </label>
                <textarea rows={3} value={formData.address} onChange={e => setFormData({
            ...formData,
            address: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1646" />
              </div>
            </div>}

          {currentStep === 1 && <div className="space-y-6" data-id="element-1647">
              <div data-id="element-1648">
                <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1649">
                  Primary Contact
                </h3>
                <div className="grid grid-cols-2 gap-4" data-id="element-1650">
                  <div data-id="element-1651">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1652">
                      Contact Person Name
                    </label>
                    <input type="text" value={formData.contactName} onChange={e => setFormData({
                ...formData,
                contactName: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1653" />
                  </div>
                  <div data-id="element-1654">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1655">
                      Email
                    </label>
                    <input type="email" value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1656" />
                  </div>
                  <div data-id="element-1657">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1658">
                      Phone
                    </label>
                    <input type="tel" value={formData.phone} onChange={e => setFormData({
                ...formData,
                phone: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1659" />
                  </div>
                  <div data-id="element-1660">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1661">
                      Mobile
                    </label>
                    <input type="tel" value={formData.mobile} onChange={e => setFormData({
                ...formData,
                mobile: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1662" />
                  </div>
                </div>
              </div>

              <div className="pt-4 border-t border-gray-200" data-id="element-1663">
                <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1664">
                  Authorized Person
                </h3>
                <div className="grid grid-cols-2 gap-4" data-id="element-1665">
                  <div data-id="element-1666">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1667">
                      Authorized Person Name
                    </label>
                    <input type="text" value={formData.authName} onChange={e => setFormData({
                ...formData,
                authName: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1668" />
                  </div>
                  <div data-id="element-1669">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1670">
                      Designation
                    </label>
                    <input type="text" value={formData.authDesignation} onChange={e => setFormData({
                ...formData,
                authDesignation: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1671" />
                  </div>
                  <div data-id="element-1672">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1673">
                      Authorized Email
                    </label>
                    <input type="email" value={formData.authEmail} onChange={e => setFormData({
                ...formData,
                authEmail: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1674" />
                  </div>
                  <div data-id="element-1675">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1676">
                      Authorized Phone/Mobile
                    </label>
                    <input type="tel" value={formData.authPhone} onChange={e => setFormData({
                ...formData,
                authPhone: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1677" />
                  </div>
                </div>
              </div>
            </div>}

          {currentStep === 2 && <div className="space-y-4" data-id="element-1678">
              <div className="grid grid-cols-2 gap-4" data-id="element-1679">
                <div data-id="element-1680">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1681">
                    Bank Name
                  </label>
                  <input type="text" value={formData.bankName} onChange={e => setFormData({
              ...formData,
              bankName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1682" />
                </div>
                <div data-id="element-1683">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1684">
                    Branch Name
                  </label>
                  <input type="text" value={formData.branchName} onChange={e => setFormData({
              ...formData,
              branchName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1685" />
                </div>
                <div data-id="element-1686">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1687">
                    Account Name
                  </label>
                  <input type="text" value={formData.accountName} onChange={e => setFormData({
              ...formData,
              accountName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1688" />
                </div>
                <div data-id="element-1689">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1690">
                    Account Number
                  </label>
                  <input type="text" value={formData.accountNumber} onChange={e => setFormData({
              ...formData,
              accountNumber: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1691" />
                </div>
                <div data-id="element-1692">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1693">
                    Routing Number
                  </label>
                  <input type="text" value={formData.routingNumber} onChange={e => setFormData({
              ...formData,
              routingNumber: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1694" />
                </div>
              </div>
            </div>}

          {currentStep === 3 && <div className="space-y-4" data-id="element-1695">
              <div data-id="element-1696">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1697">
                  Legal Documents *
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1698" />
                <p className="text-xs text-gray-500 mt-1" data-id="element-1699">
                  Upload Trade License, TIN, BIN, etc. (PDF or Image)
                </p>
              </div>
            </div>}

          {currentStep === 4 && <div className="space-y-6" data-id="element-1700">
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-1701">
                <div className="flex items-center justify-between mb-3" data-id="element-1702">
                  <h4 className="font-semibold text-gray-900" data-id="element-1703">
                    Organization Information
                  </h4>
                  <button onClick={() => setCurrentStep(0)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-1704">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-1705">
                  <div data-id="element-1706">
                    <span className="text-gray-600" data-id="element-1707">Name:</span>{' '}
                    <span className="font-medium" data-id="element-1708">
                      {formData.orgName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1709">
                    <span className="text-gray-600" data-id="element-1710">Business Type:</span>{' '}
                    <span className="font-medium" data-id="element-1711">
                      {formData.businessType || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1712">
                    <span className="text-gray-600" data-id="element-1713">Country:</span>{' '}
                    <span className="font-medium" data-id="element-1714">
                      {formData.country || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-1715">
                <div className="flex items-center justify-between mb-3" data-id="element-1716">
                  <h4 className="font-semibold text-gray-900" data-id="element-1717">Contact Info</h4>
                  <button onClick={() => setCurrentStep(1)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-1718">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-1719">
                  <div data-id="element-1720">
                    <span className="text-gray-600" data-id="element-1721">Contact Person:</span>{' '}
                    <span className="font-medium" data-id="element-1722">
                      {formData.contactName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1723">
                    <span className="text-gray-600" data-id="element-1724">Email:</span>{' '}
                    <span className="font-medium" data-id="element-1725">
                      {formData.email || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1726">
                    <span className="text-gray-600" data-id="element-1727">Authorized Person:</span>{' '}
                    <span className="font-medium" data-id="element-1728">
                      {formData.authName || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-1729">
                <div className="flex items-center justify-between mb-3" data-id="element-1730">
                  <h4 className="font-semibold text-gray-900" data-id="element-1731">Bank Details</h4>
                  <button onClick={() => setCurrentStep(2)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-1732">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-1733">
                  <div data-id="element-1734">
                    <span className="text-gray-600" data-id="element-1735">Bank Name:</span>{' '}
                    <span className="font-medium" data-id="element-1736">
                      {formData.bankName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1737">
                    <span className="text-gray-600" data-id="element-1738">Account No:</span>{' '}
                    <span className="font-medium" data-id="element-1739">
                      {formData.accountNumber || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>
            </div>}
        </WizardForm>}
    </div>;
}